import { RefStatutJureCode } from './enums/ref-statut-jure.enum';

export class StatutJure {
    static jsonMap = {
        id: 'id',
        code: 'code',
        libelle: 'libelle'
    };

    id: number;
    code: RefStatutJureCode;
    libelle: string;
}
